import db from 'database';
import Helpers, { findEarliestAvailableID } from 'shared/helpers';
import moment from 'moment';

export default class Produto {
  _id;
  nome;
  user;
  classificacao;
  NO3;
  NH4;
  NH2;
  P2O5;
  K2O;
  S;
  Ca;
  CaO;
  Mg;
  MgO;
  B;
  Cu;
  Fe;
  Mn;
  Mo;
  Zn;
  Cl;
  createdAt;
  updatedAt;
  deletedAt;

  /**
   *
   * @param {Object} data
   */
  constructor(data) {
    Helpers.constructModel(data, this);
  }

  async save() {
    this.updatedAt = moment()
      .toDate()
      .toISOString();
    this._id = await findEarliestAvailableID(db, 'produtos');
    return db.produtos.put(this);
  }

  static describe = () =>
    '++_id, nome, user, classificacao, NO3, NH4, NH2, P2O5, K2O, S, Ca, CaO, Mg, MgO, B, Cu, Fe, Mn, Mo, Zn, Cl, createdAt, updatedAt, deletedAt';
}
